/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {confirmDisclosure} from '../api'

export const useMutationConfirmDisclosure = createReactQueryMutationHook('confirmDisclosure', confirmDisclosure)
